<template>
	<div class="jurisdiction-box">
		<!--<p style="color: red;">{{slipDatas[statusCode].context}} </p>-->
	
	</div>
</template>

<script>
	export default {

		data() {
			return {
				slipDatas:{
					'503': {
						context: '您还没有注册码标或您注册的码标正在审核，暂不能注册品类码标',
						router: 'perfect'
					},
					'5': {
						context: '个人用户暂不支持此功能',
					}
				}
			}
		}, 
		props: ['statusCode'],
		computed: {
			slipHint() {
				
			}

		}

	}
</script>

<style lang="scss">
	.jurisdiction-box{
		border: solid red 1px;
		
	}

</style>